import React, { useEffect, createContext, useState } from 'react';

import { UNIT_SYSTEMS } from '../../utils/constants';

export const PreferredUnitsContext = createContext();

const PreferredUnitsProvider = (props) => {
    const [preferredUnitSystem, setPreferredUnitSystem] = useState(UNIT_SYSTEMS.metric);
    const localStorageKey = 'preferredUnitSystem';

    useEffect(() => {
        // on initial render, set context value from local storage if it exists
        const storedPreferredUnits = localStorage.getItem(localStorageKey);
        if (storedPreferredUnits === UNIT_SYSTEMS.imperial || storedPreferredUnits === UNIT_SYSTEMS.metric) {
            setPreferredUnitSystem(storedPreferredUnits);
        }
    }, []);

    const updatePreferredUnitSystem = (unitSystem) => {
        setPreferredUnitSystem(unitSystem);
        localStorage.setItem(localStorageKey, unitSystem);
    }

    return (
        <PreferredUnitsContext.Provider value={[preferredUnitSystem, updatePreferredUnitSystem]}>
            {props.children}
        </PreferredUnitsContext.Provider>
    );
};

export default PreferredUnitsProvider;